// extracted by mini-css-extract-plugin
export default {"category_card":"CategoryCard_category_card__DjQ7J"};